module.exports = __webpack_public_path__ + "img/feedc.6cc5aa07.svg";